/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListOperationsResponse {
    getFixupPrototypeFunction() { return ListOperationsResponse.fixupPrototype; }

    static newInstance(model: Partial<ListOperationsResponse>): ListOperationsResponse {
        let obj = Object.assign(new ListOperationsResponse(), model);
        ListOperationsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListOperationsResponse>): ListOperationsResponse {
        if (!model) return null;
        return ListOperationsResponse.newInstance(<ListOperationsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListOperationsResponse) {
        if (!obj) return;

        models.ListOperationsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListOperationsResponse): boolean {
        Object.setPrototypeOf(obj, ListOperationsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Operations List
     */
    data: Array<string>;

}
